import type { DviInspection, DviTemplate, DviItem, DviDecision } from './types';

function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}
function csrfHeaders(): Record<string, string> {
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  const c = readCookie('pacebi_csrf');
  if (c) h['X-CSRF-Token'] = c;
  return h;
}
async function j<T>(res: Response): Promise<T> {
  if (!res.ok) {
    if (res.status === 404) throw new Error('404: módulo DVI no habilitado');
    throw new Error(`dvi failed: ${res.status}`);
  }
  return (await res.json()) as T;
}

export async function fetchDviTemplate(): Promise<DviTemplate> {
  return j(await fetch('/api/dvi/template', { credentials: 'same-origin' }));
}
export async function createDvi(sid: number, tnum: number, equipNum: number): Promise<DviInspection> {
  return j(await fetch('/api/dvi', { method: 'POST', credentials: 'same-origin', headers: csrfHeaders(),
    body: JSON.stringify({ sid, tnum, equip_num: equipNum }) }));
}
export async function saveDvi(id: string, items: Pick<DviItem, 'id' | 'status' | 'note' | 'recommended' | 'est_price' | 'photo'>[]): Promise<DviInspection> {
  return j(await fetch(`/api/dvi/${id}`, { method: 'PUT', credentials: 'same-origin', headers: csrfHeaders(),
    body: JSON.stringify({ items }) }));
}
export async function completeDvi(id: string): Promise<DviInspection> {
  return j(await fetch(`/api/dvi/${id}/complete`, { method: 'POST', credentials: 'same-origin', headers: csrfHeaders() }));
}
export async function fetchDvi(id: string): Promise<DviInspection> {
  return j(await fetch(`/api/dvi/${id}`, { credentials: 'same-origin' }));
}
export async function fetchDviRecent(sid: number | null): Promise<DviInspection[]> {
  const q = sid ? `?sid=${sid}` : '';
  return j(await fetch(`/api/dvi/recent${q}`, { credentials: 'same-origin' }));
}
// public (no session / no CSRF)
export async function publicFetchDvi(token: string): Promise<DviInspection> {
  return j(await fetch(`/api/public/dvi/${token}`));
}
export async function publicDviDecision(token: string, itemId: string, decision: DviDecision): Promise<void> {
  const res = await fetch(`/api/public/dvi/${token}/decision`, { method: 'POST',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ item_id: itemId, decision }) });
  if (!res.ok) throw new Error(`decision failed: ${res.status}`);
}
